
export abstract class KioskSettingTypes {
    public static Boolean = "Boolean";
    public static General = "General";
    public static Health = "Health";
    public static HealthMeasurement = "HealthMeasurement";
    public static Integer = "Integer";
    public static KioskCommand = "KioskCommand";
    public static PaymentProcessor = "PaymentProcessor";
    public static Ticket = "Ticket";
    public static Workflow = "Workflow";
}